import React, { useState } from "react";
import { Form, Button } from "react-bootstrap";
import { Formik } from "formik";
import { withRouter } from "react-router-dom";

import { useUser } from "../firebase";
import FormTextbox from "../components/FormTextbox";
import FormSuggest from "../components/FormSuggest";
import FormSelect from "../components/FormSelect";
import EditContainer from "./EditContainer";
import Collabsible from "./Collabsible";

import { stateOptions } from "../schema";

const initialValue = {
  name: "",
  kvisYear: "",
  country: "",
  state: "",
  uniName: "",
  degree: "",
  major: "",
  scholarship: "",
  jobTitle: "",
  employer: "",
  jobField: ""
};

const countLabelMap = lv => {
  if (!lv) return "";
  const count = lv.count || 0;
  const label = lv.label || "";
  return `${label} [${count}]`;
};

const SearchBox = ({ history, values, ...props }) => {
  const { options } = useUser();
  const [error, setError] = useState("");

  const handleSubmit = (values, actions) => {
    const path = Object.entries(values)
      .filter(entry => entry[1] !== "")
      .map(entry => `${entry[0]}=${encodeURIComponent(entry[1])}`)
      .join("&");
    actions.setSubmitting(false);
    if (path) {
      setError("");
      history.push(`/search?${path}`);
    } else {
      setError("At least one criterion is required.");
    }
  };
  if (!values) {
    values = initialValue;
  } else {
    values = { ...initialValue, ...values };
  }

  return (
    <EditContainer title="Search" noAdd>
      <Formik initialValues={values} onSubmit={handleSubmit} enableReinitialize>
        {formik => (
          <Form noValidate className="mt-3" onSubmit={formik.handleSubmit}>
            <FormTextbox formik={formik} controlId="name" label="Name" />
            <FormSelect
              formik={formik}
              controlId="kvisYear"
              label="Class Year"
              options={options.kvisYear}
              defaultOption="Any"
              labelMap={countLabelMap}
            />
            <Collabsible
              title="Place"
              defaultOpen={!!values.country || !!values.state}
            >
              <FormSelect
                formik={formik}
                controlId="country"
                label="Country"
                defaultOption="Any"
                options={options.country}
                onChange={() => formik.setFieldValue("state", "")}
                labelMap={countLabelMap}
              />
              <FormSelect
                formik={formik}
                controlId="state"
                label="State"
                defaultOption="Any"
                options={stateOptions[formik.values.country]}
              />
            </Collabsible>
            <Collabsible
              title="Education"
              defaultOpen={
                !!values.uniName ||
                !!values.degree ||
                !!values.major ||
                !!values.scholarship
              }
            >
              <FormSuggest
                formik={formik}
                controlId="uniName"
                label="University Name"
                labelMap={countLabelMap}
                options={options.uniName}
              />
              <FormSelect
                formik={formik}
                controlId="degree"
                label="Degree"
                defaultOption="Any"
                options={options.degree}
                labelMap={countLabelMap}
              />
              <FormSuggest
                formik={formik}
                controlId="major"
                label="Major"
                labelMap={countLabelMap}
                options={options.major}
              />
              <FormTextbox
                formik={formik}
                controlId="scholarship"
                label="Scholarship"
              />
            </Collabsible>
            <Collabsible
              title="Career"
              defaultOpen={
                !!values.jobTitle || !!values.employer || !!values.jobField
              }
            >
              <FormTextbox
                formik={formik}
                controlId="jobTitle"
                label="Job Title"
              />
              <FormTextbox
                formik={formik}
                controlId="employer"
                label="Employer"
              />
              <FormSelect
                formik={formik}
                controlId="jobField"
                label="Job Field"
                defaultOption="Any"
                options={options.jobField}
                labelMap={countLabelMap}
              />
            </Collabsible>
            {error && (
              <Form.Control.Feedback type="invalid" className="d-block">
                {error}
              </Form.Control.Feedback>
            )}
            <div className="d-flex justify-content-between mt-2">
              <Button
                variant="link"
                onClick={() => formik.setValues(initialValue)}
              >
                Clear
              </Button>
              <Button type="submit">Search</Button>
            </div>
          </Form>
        )}
      </Formik>
    </EditContainer>
  );
};

export default withRouter(SearchBox);
